module.exports = __webpack_public_path__ + "media/images/sample/ic_facebook@2x-81defa0a021b5061561720aecb2d9640.png";